import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cc47f63c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "pt-2"
};
import { ref } from "vue";
import { useIsMobile } from "@/utils/reactive";
import MemberLink from "@/components/groups/MemberLink.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    groupId: null,
    label: {
      default: "Invite a user"
    },
    searchLabel: {
      default: "Search a user"
    },
    excluded: {
      default: function _default() {
        return [];
      }
    }
  },
  emits: ["show", "search", "link"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
        emit = _ref.emit;
    var isMobile = useIsMobile();
    var show = ref(false);
    var modalVisible = ref(false);

    var open = function open() {
      modalVisible.value = true;
      show.value = true;
    };

    var close = function close() {
      modalVisible.value = false;
      show.value = false;
    };

    var link = function link(user) {
      emit("link", user);
      close();
    };

    expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_el = _resolveComponent("n-el");

      var _component_n_popover = _resolveComponent("n-popover");

      var _component_n_modal = _resolveComponent("n-modal");

      return !_unref(isMobile) ? (_openBlock(), _createBlock(_component_n_popover, {
        key: 0,
        show: show.value,
        trigger: "manual",
        placement: "top-start",
        class: "lookup-popover",
        onClickoutside: _cache[2] || (_cache[2] = function ($event) {
          return show.value = false;
        }),
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return emit('show');
        })
      }, {
        trigger: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "action", {
            trigger: function trigger() {
              return show.value = true;
            },
            label: __props.label
          }, function () {
            return [_createVNode(_component_n_button, {
              type: "info",
              onClick: _cache[0] || (_cache[0] = function ($event) {
                return show.value = true;
              })
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(__props.label), 1)];
              }),
              _: 1
            })];
          })];
        }),
        header: _withCtx(function () {
          return [_createVNode(_component_n_text, {
            strong: "",
            depth: "1"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.searchLabel), 1)];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_n_el, null, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createVNode(MemberLink, {
                groupId: __props.groupId,
                focus: true,
                excluded: __props.excluded,
                onSearch: _cache[1] || (_cache[1] = function (query) {
                  return emit('search', query);
                }),
                onLink: link
              }, null, 8, ["groupId", "excluded"])])];
            }),
            _: 1
          })];
        }),
        _: 3
      }, 8, ["show"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_renderSlot(_ctx.$slots, "action", {
        trigger: function trigger() {
          return modalVisible.value = true;
        },
        label: __props.label
      }, function () {
        return [_createVNode(_component_n_button, {
          type: "info",
          onClick: _cache[4] || (_cache[4] = function ($event) {
            return modalVisible.value = true;
          })
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(__props.label), 1)];
          }),
          _: 1
        })];
      }), _createVNode(_component_n_modal, {
        show: modalVisible.value,
        "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
          return modalVisible.value = $event;
        }),
        "auto-focus": false,
        preset: "card",
        title: __props.searchLabel
      }, {
        default: _withCtx(function () {
          return [_createVNode(MemberLink, {
            groupId: __props.groupId,
            excluded: __props.excluded,
            onSearch: _cache[5] || (_cache[5] = function (query) {
              return emit('search', query);
            }),
            onLink: link
          }, null, 8, ["groupId", "excluded"])];
        }),
        _: 1
      }, 8, ["show", "title"])], 64));
    };
  }
});